//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'
import userData from '~/mixins/user/userData'
import formattedDate from '~/filters/formattedDate.js'
import { translateOrDefault } from '~/filters/translateOrDefault'
import CurrencyDropdown from '~/components/CurrencyDropdown'
import ContactDropdown from '~/components/ContactDropdown'
import GTM from '~/utils/classes/Gtm'
import settings from '~/mixins/settings'
import dayjs from "dayjs";

export default {
  name: 'HeaderContainer',
  components: {
    NotificationDropdown: () => import('~/components/NotificationDropdown'),
    ProfileDropdown: () => import('~/components/ProfileDropdown'),
    MobileMenuModal: () => import('~/components/modal/mobile-menu-modal'),
    ContactDropdown,
    CurrencyDropdown,
    LocaleDropdown
  },
  filters: { formattedDate, translateOrDefault, formatDate (date) {
      return dayjs(date).format('DD/MM/YYYY')
  }},
  mixins: [userData, settings],
  props: {
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      appName: process.env.appName,
      isMobileDropdown: false,
      gtm: new GTM(this.$gtm),
      recently: false,
      badge: true
    }
  },
  watch: {
    $route () {
      this.isMobileDropdown = false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      check: 'auth/check',
      locale: 'lang/locale',
      language: 'lang/currentLanguage',
      sysNotifications: 'dashboard/notifications',
      appTheme: 'appTheme'
    }),
    showBadge () {
      return this.badge && !!['index'].includes(this.$route.name)
    },
    lang () {
      return this.locale === 'nl' ? 'nl' : 'en'
    },
    checkRecently () {
      this.getRecently()
      const onPage = ['index', 'destination-location', 'search'].includes(this.$route.name)
      return !!this.recently && onPage
    },
  },
  methods: {
    hideBadge () {
      this.badge = false
    },
    getRegisterAction () {
      this.$router.push({ name: 'register' })
    },
    getRecently () {
      if (process.client) {
        const data = window.localStorage.getItem('viewedBoat')
        if (data) {
          const rec = JSON.parse(data)
          if (dayjs(rec.dateFrom).format('YYYY-MM-DD') > dayjs().format('YYYY-MM-DD')) {
            this.recently = rec
            return true
          }
        }
      }
      return false
    },
    removeViewed () {
      this.recently = null
      window.localStorage.removeItem('viewedBoat')
    },
    getLoginAction () {
      if (['auth'].includes(this.$nuxt.$data.layoutName)) {
        this.$router.push({ name: 'login' })
      } else {
        this.$modal.show('login-modal')
      }
    },
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push({ name: 'login' }).catch((e) => {})
    }
  },
  jsonld () {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'Product',
      name: 'Tubber',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: this.getSettingsReviewAVG,
        ratingCount: this.getSettingsReviewsCount,
        bestRating: '5',
        worstRating: '1'
      }
    }
  }
}
